var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confused"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#5e6175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m220.3 49.05h6v18.71h-6z",
    transform: "matrix(.707 -.707 .707 .707 24.11 175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.4 77.44h18.71v6h-18.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.2 36h6v18.71h-6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m91.23 110.36-49.58 32.05 49.58 33.67h185.23v-65.72z",
    fill: "#e1830e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.02 176.08h-168.7v64.11h168.7l49.58-32.05z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.14 237a9.18 9.18 0 1 1 15.69-6.43 9.19 9.19 0 0 1 -15.69 6.43zm6.52-9.64a3.17 3.17 0 1 0 3.17 3.19 3.18 3.18 0 0 0 -3.17-3.23z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.72 160.57a10 10 0 1 1 17-7 10 10 0 0 1 -17 7zm7.07-11a4 4 0 1 0 2.8 1.17 4 4 0 0 0 -2.8-1.13z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.66 210.46a12.55 12.55 0 0 1 8.9-21.35c11.06 0 16.8 13.5 8.82 21.42a12.53 12.53 0 0 1 -17.72-.07zm8.9-15.35a6.53 6.53 0 1 0 4.63 1.93 6.54 6.54 0 0 0 -4.63-1.93z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.19 194.34c-.46-.01.46-.01 0 0z",
    fill: "#e1830e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.32 402.55h-36v-313.55a18 18 0 0 1 36 0z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.32 405.55h-42v-316.55a21 21 0 0 1 42 0zm-36-6h30v-310.55a15 15 0 0 0 -30 0z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.34 380a17 17 0 0 0 -11.11 4c-8.26 7.1-13.1 16.84-15 21.14h-1.74c-6.24-14.89-20.06-24.74-27.16-29a17.2 17.2 0 0 0 -8.85-2.43h-1.41c20.31 24.6 15.62 55.56 15.62 55.56h41.2c-6.44-25.27 8.45-49.27 8.45-49.27z",
    fill: "#e1830e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.93 335.16h-6v-6h6zm0-16h-6v-6h6zm0-16h-6v-6h6zm0-16h-6v-6h6zm0-16h-6v-6h6zm0-16h-6v-6h6z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.46 351.28h71.11v77.98h-71.11z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.78 426.25h247.3v6h-247.3z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.06,
    cy: 410.71,
    fill: "#f5f5f5",
    r: 65.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.06 479a68.3 68.3 0 1 1 68.29-68.29 68.37 68.37 0 0 1 -68.29 68.29zm0-130.59a62.3 62.3 0 1 0 62.29 62.3 62.37 62.37 0 0 0 -62.29-62.3z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.27 426.27h-14.42a30.82 30.82 0 0 1 12.8-25 9.59 9.59 0 1 0 -15.17-7.79h-14.42a24 24 0 1 1 38 19.49 16.37 16.37 0 0 0 -6.79 13.3z",
    fill: "#e1830e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.69 437.42h14.48v14.48h-14.48z",
    fill: "#e1830e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e0f64d9860d4538142b0cfcd9c947a20.svg";
export { ForwardRef as ReactComponent };